/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from '../../../core/lib';
import { Input } from '../Input';
import { TranslationID } from '../Input/utils';

// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop(): void {}

export interface IFormInputProps {
    id?: string;
    name: string;
    type: string;
    onChange?: (value: string, obj?: any) => void;
    onInputIsValid?: (value: boolean) => void;
    placeholder?: string;
    label?: string;
    maxLength?: number;
    focusWhenMount?: boolean;
    errorFromBackend?: string;
    value?: string;
    validInput?: boolean;
    showTooltipSuccess?: boolean;
    translations?: Record<TranslationID, string>;
    submit?: boolean;
    checked?: boolean;
    children?: React.ReactChild;
    error?: boolean;
    fromSearch?: boolean;
    IsTypeTootlipOther?: boolean;
    onFocus?: () => void;
}

export class FormInput extends React.Component<IFormInputProps> {
    private previousValue: string;
    private isFirstCharge: boolean;

    public static contextTypes = {
        $form: PropTypes.object
    };

    public static defaultProps = {
        onChange: noop
    };

    public componentWillMount(): void {
        if (!this.context) {
            throw new Error('FormInput must be used within a Form');
        }
    }

    public componentDidMount(): void {
        const { focusWhenMount, maxLength, name } = this.props;
        const value = this.getCurrentValue();
        this.isFirstCharge = true;
        this.previousValue = value;
        if(focusWhenMount){
            this.handleFocus();
        }
        if(maxLength && !isNaN(maxLength)){
            const { $form: { setFieldMaxLength} } = this.context;
            setFieldMaxLength(name, maxLength);
        }
    }

    public componentDidUpdate(): void {
        const { onChange, value: propValue = false } = this.props;
        
        if(this.isFirstCharge){
            if(propValue){
                const {
                    $form: { appendValue, values, activeField }
                } = this.context;
                const {[activeField]: activeFieldValue} = values;
                if(activeField === this.props.name && propValue !== activeFieldValue){
                    appendValue(propValue);
                }
            }
            this.isFirstCharge = false;
        }
        let value = this.getCurrentValue();
        const hasCorrectLength = this.props.maxLength ? (value.length <= this.props.maxLength) : true;
        if (value !== this.previousValue && hasCorrectLength) {
            this.previousValue = value;
            onChange!(value, this);
        }
    }

    private getCurrentValue(): string {
        const { name } = this.props;
        const {
            $form: { values }
        } = this.context;
        return values[name] ?? '';
    }

    private getSelected(): string {
        const { name } = this.props;
        const {
            $form: { activeField }
        } = this.context;
        return activeField;
    }

    @autobind
    private handleFocus(): void {
        const { name, onFocus } = this.props;
        const {
            $form: { updateFocusedField }
        } = this.context;
        if (onFocus && typeof onFocus === 'function') {
            onFocus();
        }
        updateFocusedField(name);
    }


    @autobind
    private handleSelection(): void {
        const { name, type } = this.props;
        const {
            $form: { updateActiveField }
        } = this.context;
       
        switch (type) {
            case 'alphanumeric':
            case 'password':
            case 'password_shown':
            case 'email':
            case 'text':
            case 'mobile':
            case 'validation_code':
            case 'pin':
            case 'numeric':
                updateActiveField(name);
                break
            default:
                break
        }        
    }

    public render(): JSX.Element {
        const {focusWhenMount, id, type, name, placeholder, onInputIsValid, label, maxLength, errorFromBackend, validInput, showTooltipSuccess , translations, checked, onChange, submit, error, children,fromSearch = false, IsTypeTootlipOther} = this.props;
        const value: string =  this.props.value ?? this.getCurrentValue();
        const selected = this.getSelected();
        return (
            <Input
                focusWhenMount = {focusWhenMount}
                selectedInput= {selected}
                onFocus={this.handleFocus}
                onInputIsValid={onInputIsValid}
                name={name}
                id={id}
                label= {label}
                type={type}
                value={value}
                placeholder={placeholder}
                classNamePass= {name === 'password' ?  (IsTypeTootlipOther ? 'aaf_tooltip-password-others' : 'aaf_tooltip-password') : ''}
                maxLength= {maxLength}
                errorFromBackend={errorFromBackend}
                validInput={validInput}
                showTooltipSuccess={showTooltipSuccess}
                translations={translations}
                checked = {checked}
                onChange = {onChange}
                submit = {submit}
                onClick = {this.handleSelection}
                children={children}
                error = {error}
                fromSearch={fromSearch}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/packages/components/lib/FormInput/index.tsx